var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var stack1;
  return escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Announcement)),stack1 == null || stack1 === false ? stack1 : stack1.body)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  }

function program3(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "/announcement/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Announcement)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  return buffer;
  }

  buffer += "<a\n  class=\"announcement__list__link\"\n  href=\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Announcement)),stack1 == null || stack1 === false ? stack1 : stack1.is_link), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n>\n  <p class=\"announcement__list__link__message\">\n    "
    + escapeExpression(__default(require("../js/hbs_helpers/truncate.js")).call(depth0, ((stack1 = (depth0 && depth0.Announcement)),stack1 == null || stack1 === false ? stack1 : stack1.title), 55, {hash:{},data:data}))
    + "\n  </p>\n</a>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/announcement_list_content.hbs
// module id = 187
// module chunks = 0 1